import React from 'react';

type V2IconProps = {
  name:
    | 'players'
    | 'chart'
    | 'card'
    | 'help'
    | 'gift'
    | 'compact'
    | 'search'
    | 'filter'
    | 'menu'
    | 'dice'
    | 'autopaste'
    | 'settings';
  className?: string;
};

const V2Icon: React.FC<V2IconProps> = ({ name, className }) => {
  const common = {
    viewBox: '0 0 24 24' as const,
    'aria-hidden': true,
    className: className ? `v2-icon ${className}` : 'v2-icon',
  };

  switch (name) {
    case 'players':
      return (
        <svg {...common}>
          <circle cx="9" cy="8" r="3" />
          <path d="M3 20v-3a6 6 0 0 1 12 0v3M16 5a3 3 0 0 1 0 6M18 14a5 5 0 0 1 3 5" />
        </svg>
      );
    case 'chart':
      return (
        <svg {...common}>
          <path d="M3 21h18M5 20v-7h4v7M10 20V4h4v16M15 20v-12h4v12" />
        </svg>
      );
    case 'card':
      return (
        <svg {...common}>
          <rect x="3" y="5" width="18" height="14" rx="1" />
          <path d="M3 9h18M6 15h5" />
        </svg>
      );
    case 'help':
      return (
        <svg {...common}>
          <circle cx="12" cy="12" r="9" />
          <path d="M9 9a3 3 0 0 1 6 0c0 2-3 2-3 4M12 16h.01" />
        </svg>
      );
    case 'gift':
      return (
        <svg {...common}>
          <rect x="3" y="8" width="18" height="4" />
          <path d="M5 12v9h14v-9M12 8v13M12 8S5 9 5 5a3 3 0 0 1 6-1l1 4Zm0 0s7 1 7-3a3 3 0 0 0-6-1l-1 4Z" />
        </svg>
      );
    case 'compact':
      return (
        <svg {...common}>
          <path d="M8 3v5H3M16 3v5h5M3 16h5v5M21 16h-5v5" />
        </svg>
      );
    case 'search':
      return (
        <svg {...common}>
          <circle cx="10" cy="10" r="6" />
          <path d="m15 15 6 6" />
        </svg>
      );
    case 'filter':
      return (
        <svg {...common}>
          <path d="M3 6h18M3 12h18M3 18h18" />
          <circle cx="8" cy="6" r="2" fill="var(--bg)" />
          <circle cx="16" cy="12" r="2" fill="var(--bg)" />
          <circle cx="10" cy="18" r="2" fill="var(--bg)" />
        </svg>
      );
    case 'menu':
      return (
        <svg {...common}>
          <path d="M4 7h16M4 12h16M4 17h16" />
        </svg>
      );
    case 'dice':
      return (
        <svg {...common}>
          <rect x="5" y="5" width="14" height="14" rx="2.5" />
          <circle cx="9" cy="9" r="1.1" fill="currentColor" stroke="none" />
          <circle cx="15" cy="15" r="1.1" fill="currentColor" stroke="none" />
        </svg>
      );
    case 'autopaste':
      return (
        <svg {...common}>
          <rect x="8" y="3" width="8" height="4" rx="1" />
          <path d="M7 5H6a2 2 0 0 0-2 2v11a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7a2 2 0 0 0-2-2h-1" />
          <path d="M9 12h6M9 16h4" />
        </svg>
      );
    case 'settings':
      return (
        <svg {...common}>
          <path d="m9 3-.5 2.5-2 1.2-2.4-.8-2 3.4L4 11v2l-1.9 1.7 2 3.4 2.4-.8 2 1.2L9 21h6l.5-2.5 2-1.2 2.4.8 2-3.4L20 13v-2l1.9-1.7-2-3.4-2.4.8-2-1.2L15 3Z" />
          <circle cx="12" cy="12" r="3" />
        </svg>
      );
    default:
      return null;
  }
};

export default V2Icon;
